import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import MoodleReaderForm from '../forms/moodle-reader-form';
import { moodleReaderValidationSchema } from '../schema/moodleReader.js';

export default function MoodleReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Moodle Reader Node Details',
        altText: 'Moodle Reader Node',
        defaultLabel: 'Moodle Reader Node',
      }}
    >
      <CommonNode FormComponent={MoodleReaderForm} schemaResolver={moodleReaderValidationSchema} />
    </NodeProvider>
  );
}
